import type { PhoneFramePreset } from 'src/shared/PhoneFrame';

export type AppAlertType = 'modal' | 'banner';
export type BannerPreviewVariant = 'short' | 'tall';

export interface AppAlertFormValues {
  title: string;
  heroImageUrl: string;
  bgImageUrl: string;
  textColor: string;
  buttonCopy: string;
  buttonUrl: string;
  headingText: string;
  textBlock: string;
  bgType: 'color' | 'image';
  bgColor: string;
  bgTransparent: boolean;
  verticalAlignment: 'flex-start' | 'center' | 'flex-end';
  buttonColor: string;
  buttonStyle: 'filled' | 'outline' | 'plain';
  alertType: AppAlertType;
  highContrastButton: boolean;
  hideCloseButton: boolean;
}

export const PHONE_PRESETS: PhoneFramePreset[] = [
  {
    id: 'iphone-14-pro-max',
    name: 'iPhone 14 Plus/iPhone 14 Pro Max',
    width: 430,
    height: 932,
  },
  {
    id: 'iphone-14',
    name: 'iPhone 14/iPhone 14 Pro',
    width: 390,
    height: 844,
  },
  {
    id: 'iphone-se',
    name: 'iPhone SE',
    width: 375,
    height: 667,
  },
  {
    id: 'pixel-5',
    name: 'Pixel 5',
    width: 393,
    height: 851,
  },
  {
    id: 'galaxy-s8-plus',
    name: 'Samsung Galaxy S8+',
    width: 360,
    height: 740,
  },
  {
    id: 's20-ultra',
    name: 'Samsung Galaxy S20 Ultra',
    width: 412,
    height: 915,
  },
];

export const PHONE_SCALES = [
  { id: '1', factor: 1, label: '100%' },
  { id: '0.75', factor: 0.75, label: '75%' },
  { id: '0.5', factor: 0.5, label: '50%' },
  { id: '0.25', factor: 0.25, label: '25%' },
];

export const BUTTON_STYLE_IDS: Array<AppAlertFormValues['buttonStyle']> = [
  'filled',
  'outline',
  'plain',
];

export const BUTTON_COLOR_IDS = [
  'primary',
  'secondary',
  'default',
  'success',
  'error',
] as const;

export const TEXT_COLOR_IDS = [
  'default',
  'text-darkmode',
  'text2-darkmode',
  'text',
  'text2',
] as const;

export const VERTICAL_ALIGNMENT_IDS: Array<
  AppAlertFormValues['verticalAlignment']
> = ['flex-start', 'center', 'flex-end'];
